import { render, staticRenderFns } from "./ProductDescription.vue?vue&type=template&id=b29b9282&scoped=true"
import script from "./ProductDescription.vue?vue&type=script&lang=ts"
export * from "./ProductDescription.vue?vue&type=script&lang=ts"
import style0 from "./ProductDescription.vue?vue&type=style&index=0&id=b29b9282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29b9282",
  null
  
)

export default component.exports